import { render, staticRenderFns } from "./financialTitleDetail.vue?vue&type=template&id=7ca1c7e4"
import script from "./financialTitleDetail.vue?vue&type=script&lang=js"
export * from "./financialTitleDetail.vue?vue&type=script&lang=js"
import style0 from "./financialTitleDetail.vue?vue&type=style&index=0&id=7ca1c7e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnGroup,QBtn,QScrollArea,QCard,QCardSection});
